import { ReconfigureAgentSchedulerFormView } from '../view/ReconfigureAgentSchedulerFormView';
import { templateReconfigureAgentSchedulerForm } from '../view/template';
import {
  BaseWebComponentController,
  IListenerConfig,
  WebComponentEvent,
} from '../../../../../framework/BaseWebComponentController';
import { ReconfigureAgentSchedulerFormWebComponent } from '../component/ReconfigureAgentSchedulerFormWebComponent';
import { RadioEvent } from '../../../../../ui/gzRadio/types';
import { SchedulerMode } from '../types/SchedulerMode';
import { MultiSelectEvents } from '../../../../../ui/gzMultiSelect/types';
import { WeekDays } from '../types';

export class ReconfigureAgentSchedulerFormController extends BaseWebComponentController {
  public component: ReconfigureAgentSchedulerFormWebComponent;
  public view: ReconfigureAgentSchedulerFormView;
  public viewConstructor: typeof ReconfigureAgentSchedulerFormView;

  constructor(component: ReconfigureAgentSchedulerFormWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: ReconfigureAgentSchedulerFormView,
      viewTemplate: templateReconfigureAgentSchedulerForm,
    });
  }

  computeEventListeners(): IListenerConfig[] {
    return [
      {
        element: this.view.dom.$reconfigureSchedulerFormField,
        event: RadioEvent.SELECTION_CHANGED,
        callback: this.schedulerOptionChanged,
      },
      {
        element: this.view.dom.$recurrenceFormField,
        event: 'selectionChanged',
        callback: this.recurrenceOptionChanged,
      },
      {
        element: this.view.dom.$recurrenceWeeklyFormField,
        event: MultiSelectEvents.CHANGE,
        callback: this.recurrenceWeeklyDayChanged,
      },
    ];
  }

  private recurrenceWeeklyDayChanged(): void {
    const selectedDays = this.view.dom.$recurrenceWeeklyFormField.Input.getFormValue() as WeekDays[];
    if (selectedDays.length > 1) {
      this.view.setWeekDaysValue(this.view.dom.$recurrenceWeeklyFormField.Input.getFormValue()[1] as WeekDays);
    }
  }

  private schedulerOptionChanged(ev: WebComponentEvent): void {
    switch (ev.detail.selectedValue) {
      case SchedulerMode.Now:
        this.view.toggleScheduledSectionVisibility(false);
        break;
      case SchedulerMode.Scheduled:
        this.view.toggleScheduledSectionVisibility(true);
        break;
    }
  }

  private recurrenceOptionChanged(): void {
    this.view.toggleRecurrenceOptionVisibility(this.view.dom.$recurrenceFormField.value as number);
  }
}
